import { apiClient } from './apiClient';

export interface PlatformSettingDto {
  settingKey: string;
  settingValue: string;
  description: string;
  category: string;
  lastModifiedBy: string;
  lastModifiedAt: string;
  isReadOnly: boolean;
}

export type GroupedSettings = Record<string, PlatformSettingDto[]>;

/** Startup steps that failed without stopping the process. PlatformAdmin only. */
export interface StartupHealthDto {
  isHealthy: boolean;
  degradations: string[];
}

class PlatformSettingsService {
  async getAll(): Promise<GroupedSettings> {
    const response = await apiClient.get('/api/platform-settings');
    return response.data;
  }

  async getStartupHealth(): Promise<StartupHealthDto> {
    const response = await apiClient.get('/api/platform-settings/startup-health');
    return response.data;
  }

  async getByCategory(category: string): Promise<PlatformSettingDto[]> {
    const response = await apiClient.get(`/api/platform-settings/${category}`);
    return response.data;
  }

  async updateSetting(key: string, value: string): Promise<void> {
    await apiClient.put(`/api/platform-settings/${encodeURIComponent(key)}`, { value });
  }
}

export const platformSettingsService = new PlatformSettingsService();
